import { useEffect, useState } from "react";
import { useNavigator } from "../../../../framework/services/navigation";
import { IStormDoorHandleListing } from "../../../../entities-generated/models/storm-door/storm-door-handle-listing";
import { BwjViewManager, BwjViewState } from "../../../../framework/components/bwj-view-manager";
import { StormDoorHandleApiClient } from "../../../../services/storm-door-handle";
import { BwjPageHeader } from "../../../../framework/components/bwj-page-header";
import { AppRoutes } from "../../../app-routes";
import { BwjPageContent } from "../../../../framework/components/bwj-page-content";
import { StormHandleListItem } from "../../components/handle-listing";

export const PageViewStormHandles: React.FunctionComponent = () => {
  const nav = useNavigator();
  const [viewState, setViewState] = useState(BwjViewState.Loading);
  const [handles, setHandles] = useState<IStormDoorHandleListing[]>([]);

  useEffect(() => {
    StormDoorHandleApiClient.getStormDoorHandleList()
    .then(handles => {
      setHandles(handles);
      setViewState(BwjViewState.Ready);
    })
    .catch(() => setViewState(BwjViewState.Error));
  }, []);

  const onHandleSelected = (handle: IStormDoorHandleListing) => {
    nav.goTo(AppRoutes.editStormHandle.url(handle.id));
  }

  return (
    <BwjViewManager
      state={viewState}
      loadingState={{
        message: 'Loading Door Handles...',
      }}
      errorState={{
        message: 'An unexpected error occurred'
      }}
    >
      <BwjPageHeader
        title={'Storm Door Handle Inventory'}
        titleIconName={AppRoutes.viewStormHandles.icon}
      />
      <BwjPageContent contentDescription={'primary content (no subcontent)'}>
        {handles.map(handle =>
        <StormHandleListItem
          key={handle.id}
          handle={handle}
          onClick={onHandleSelected}
        />)}
      </BwjPageContent>
    </BwjViewManager>
  );
};